import type { ProductPageQuery } from '@/shared/apollo-api/__generated__/types';
import type { TSkuSelectorProduct } from '@/features/sku-selector';
import type { IProductEntityCharacteristic } from '@/entities';

/**
 * Преобразует данные продукта из GraphQL в формат, необходимый для SkuSelector
 * @param product - данные продукта из GraphQL
 * @returns объект с продуктами (skuList) и характеристиками для SkuSelector
 */
export function productToSkuSelectorData(product: ProductPageQuery['product']) {
  const products: TSkuSelectorProduct[] = product.skuList.map((sku) => ({
    id: product.id.toString(),
    skuId: sku.id.toString(),
    title: product.title,
    sellPrice: sku.sellPrice,
    fullPrice: sku.fullPrice,
    availableAmount: sku.availableAmount,
    photo: sku.photo.key
      ? {
          key: sku.photo.key,
          high: sku.photo.link.low, // используем low для photo, так как это основное фото
          low: sku.photo.link.low,
        }
      : undefined,
    characteristicValues: sku.characteristicValues.map((charValue) => ({
      id: charValue.id,
      label: charValue.title,
      value: charValue.value,
      characteristicId: charValue.characteristic.id,
      characteristicTitle: charValue.characteristic.title,
      characteristicType: charValue.characteristic.type as any,
    })),
  }));

  const characteristics: IProductEntityCharacteristic[] = product.characteristics.map((char) => ({
    id: char.id,
    title: char.title,
    type: char.type as any,
    values: char.values.map((value, index) => ({
      id: value.id,
      title: value.title,
      value: value.value,
      photo: value.photo?.link.low,
      order: index, // используем индекс как порядок
    })),
  }));

  return {
    products,
    characteristics,
  };
}
